import { useState, useEffect } from 'react';
import { FaCookie, FaTimes } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setTimeout(() => setIsVisible(true), 1000);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 animate-slide-up">
      <div className="container mx-auto max-w-4xl">
        <div className="bg-dark-800 border border-gray-700 rounded-xl p-6 shadow-2xl flex flex-col md:flex-row items-start md:items-center gap-4">
          <div className="flex-shrink-0">
            <FaCookie className="text-primary-400 text-3xl" />
          </div>
          
          <div className="flex-1">
            <h3 className="text-white font-semibold mb-2">We use cookies</h3>
            <p className="text-gray-400 text-sm mb-2">
              We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
              By clicking "Accept All", you consent to our use of cookies.{' '}
              <Link to="/cookies" className="text-primary-400 hover:text-primary-300 underline">
                Learn more
              </Link>
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3 w-full md:w-auto">
            <button
              onClick={handleReject}
              className="px-4 py-2 text-gray-300 hover:text-white transition-colors text-sm"
            >
              Reject
            </button>
            <button
              onClick={handleAccept}
              className="px-6 py-2 bg-gradient-to-r from-primary-500 to-accent-500 text-white font-semibold rounded-lg hover:from-primary-600 hover:to-accent-600 transition-all duration-200 shadow-lg"
            >
              Accept All
            </button>
          </div>

          <button
            onClick={handleAccept}
            className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors"
            aria-label="Close"
          >
            <FaTimes size={20} />
          </button>
        </div>
      </div>
    </div>
  );
};

